export default {
  title: 'Powiadomienia push',
  description: 'Wysyłaj ukierunkowane powiadomienia push do swoich klientów',
  buttons: {
    new_campaign: 'Nowa kampania',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Aplikacja mobilna jeszcze niedostępna',
      description: 'Poczekaj, aż aplikacja mobilna będzie dostępna, aby wysyłać powiadomienia push',
    },
  },
};
